// extracted by mini-css-extract-plugin
export default {"overlay":"newsletter_overlay__5mNdj","modal":"newsletter_modal__RI9Cb"};